module.exports = __webpack_public_path__ + "img/partners_photo-image.f49bea9e.jpg";